import esquire from "./components/esquire";
import Cookie from 'js-cookie';


require('./components/publish-jquery');

esquire.define("App/Analytics", ['gtm:dataLayer'], function (dl) {

    let analytics = undefined;
    let _ym = undefined;
    let events = ['step2', 'step3', 'step4', 'filters', 'sort', 'carDetails', 'rateDetails',
        'emailQuote', 'step3_email', 'step3_marketingEmail', 'step3_title', 'bookingSummary', 'magicLocation'];

    _ym = null;

    function pushEvent(e) {
        const gtm_event = {
            'event': 'GAevent',
            'eventCategory': e[0],
            'eventAction': e[1]
        };
        if (e[2]) {
            gtm_event['eventLabel'] = e[2];
        }
        if (e[3]) {
            gtm_event['eventValue'] = e[3];
        }
        gtm_event['nonInteractiveEvent'] = (e[4]) ? e[4] : false;

        dl.push(gtm_event);

        if (analytics.beMobile) {
            let params = {
                'action': e[1]
            };
            if (e[2]) {
                params['label'] = e[2];
            }
            if (e[3]) {
                params['value'] = e[3];
            }

            if (e[0] !== 'search') { //the search has been replaced by explicit pushToFirebase call below
                pushToFirebase(e[0], params)
            }
        }
    }

    function pushEcommerce(data) {
        if (analytics.beMobile) {
            let params = $.extend({}, data); //clone the object
            delete params['ecommerce']; //don't need it in firebase

            if (params['firebase']) {
                pushToFirebase('ecommerce_purchase', params['firebase']);
            }
        }

        delete data['firebase'];

        let gtm_event =
            {event: 'Ecommerce'};
        gtm_event = $.extend(gtm_event, data);
        dl.push(gtm_event);
    }


    function pushPageVisitDimensions(subject, type, subtype, country) {

        dl.push({
            SearchPageLocation: subject
        });
        dl.push({
            SearchPageType: type
        });

        if (subtype) {
            dl.push({
                SearchPageTailValue: subtype
            });
        }

        if (country) {
            dl.push({
                SearchPageCountry: country
            });
        }

        if (!Cookie.get('_lp_set')) {
            Cookie.set('_lp_set', 1);

            dl.push({
                LandingPageLocation: subject
            });
            dl.push({
                LandingPageType: type
            });

            if (subtype) {
                dl.push({
                    LandingPageTailValue: subtype
                });
            }

            if (country) {
                return dl.push({
                    LandingPageCountry: country
                });
            }
        }
    }

    function pushToFirebase(name, params) {
        if (!name) {
            return;
        }

        if (window.AnalyticsWebInterface) {
            window.AnalyticsWebInterface.logEvent(name, JSON.stringify(params));
        } else if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.firebase) {
            var message = {
                command: 'logEvent',
                name: name,
                parameters: params
            };

            window.webkit.messageHandlers.firebase.postMessage(message);
        } else {
            if (console !== undefined && console.log !== undefined) {
                console.log('Ups, no native APIs found')
            }
        }
    }

    function setUserProperty(name, value) {
        if (!value) {
            return;
        }

        if (window.AnalyticsWebInterface) {
            window.AnalyticsWebInterface.setUserProperty(name, value);
        } else if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.firebase) {
            var message = {
                command: 'setUserProperty',
                name: name,
                parameters: params
            };

            window.webkit.messageHandlers.firebase.postMessage(message);
        } else {
            if (console !== undefined && console.log !== undefined) {
                console.log('Ups, no native APIs found')
            }
        }
    }


    function pushVirtualPage(url, title) {
        const event = {
            'event': 'VirtualPageView',
            'virtualPageURL': `/virtual/${url}`,
            'virtualPageTitle': title
        };

        dl.push(event);
    }

    function trackGoal(id, params) {
        if (_ym) {
            _ym.reachGoal(id, null, null, params);
        }
    }

    function getSearchData(ct5_data) {
        let sd = ct5_data.searchData;
        let pickup = sd.pickup;
        let dropoff = sd.dropoff;

        return {
            origin: sd.residence,
            destination: pickup.country,
            start_date: [pickup.date_details.y, pickup.date_details.m, pickup.date_details.d].join('-'),
            end_date: [dropoff.date_details.y, dropoff.date_details.m, dropoff.date_details.d].join('-'),
            search_term: pickup.location
        }
    }

    let Analytics = class Analytics {
        constructor() {
            analytics = this;
            this.beMobile = false;

            esquire.require(['ya:metrika'], function (metrika) {
                _ym = metrika;
            });

            esquire.require(['jQCT', 'Tracker'], function ($, _tracker) {
                $.each(events, function (i, name) {
                    $(document).bind(`abeEvents_${name}`, function (e, obj) {
                        analytics.handleEvent(e, obj, name);
                        _tracker.handleEvent(e, obj, name);
                    });
                });
            });
        }

        handleCT5Event(type, status, data, api, event) {
            //            debugger
            switch (type) {
                case 'vehicles':
                    if (status === 'start') {
                        this.trackSearchStart(data.searchData.pickup.id, data, api, event);
                    } else if (status === 'success') {
                        if (data.vehiclesData.length > 0) {
                            this.trackSearchResult(data.vehiclesData.length, data, api, event);
                        } else {
                            this.trackEmptySearchResult(data, api, event);
                        }
                    }
                    break;
                case 'searchcars':
                    if (status === 'success') {
                        this.trackWrongFormParameters(data, api, event);
                    }
                    break;
                case 'vehicle':
                    if (status === 'success') {
                        this.trackCarDetails(1000, data.vehicleData.amount.totalPrice, data, api, event);
                    }
                    break;
            }
        }


        handleEvent(e, obj, name) {
            if (!obj) {
                obj = {};
            }

            switch (name) {
                case 'emailQuote':
                    if (obj.status === 'open') {
                        this.trackEmailQuoteOpen();
                    }
                    if (obj.status === 'sent') {
                        this.trackEmailQuoteSent();
                    }
                    break;
                case 'step2':
                    if (obj.process === 'start') {
                        this.trackSearchStart(obj.searchData.pickup.id);
                    } else if (obj.process === 'success') {
                        this.trackSearchResult(obj.availData.cars.length);
                    } else if (obj.process === 'nocar') {
                        this.trackEmptySearchResult();
                    }
                    break;
                case 'step3':
                    if ((obj.channel === "checkout") && (obj.process === "success") && (obj.status === "success")) {
                        this.trackCarDetails(obj.carData.rank, obj.carData.price);
                        if (obj.carData.bestPrice) {
                            this.trackBestPrice(obj.carData.price);
                        }
                    } else if ((obj.channel === "checkout") && (obj.process === "validation") && (obj.status === "validation")) {
                        this.trackValidationError(obj.error);
                    } else if (typeof (obj) === "object" && obj.hasOwnProperty('error')) {
                        this.trackCheckoutError(obj.error.name);
                    }
                    break;
                case 'step4':
                    if ((obj.channel === "Purchase") && (obj.process === "success")) {
                        return this.trackPurchaseComplete(obj.carData.currency, obj.carData.price);
                    }
                    break;
                case 'rateDetails':
                    this.trackRateDetails(CTEngine.step === 3 ? 'on payment' : undefined);
                    break;
            }
        }

        trackHomepage() {
            pushPageVisitDimensions('homepage', 'homepage');
            pushEvent(['visitor', 'on homepage', undefined, undefined, true]);
        }

        trackCountryHomepage(country) {
            pushPageVisitDimensions('country_homepage', 'country_homepage', null, country);
            pushEvent(['visitor', 'on country homepage', country, undefined, true]);
        }

        trackCountryTail(country, _type, _subtype) {
            pushPageVisitDimensions('country_tail', _type, _subtype, country);
            pushEvent(['visitor', 'on country homepage', country, undefined, true]);
        }

        trackVisitTail(location, tail, name, _type, _subtype, country) {
            pushPageVisitDimensions(name, _type, _subtype, country);
            pushEvent(['visit tail', location, tail, undefined, true]);

        }

        trackVisitLocation(locationName, locationId, name, country) {
            pushPageVisitDimensions(name, 'location', null, country);
            pushEvent(['visit location', locationId, locationName, undefined, true]);

        }

        trackVisitCity(cityName, name, country) {
            pushPageVisitDimensions(name, 'city', null, country);
            pushEvent(['visit city', cityName, undefined, undefined, true]);
        }

        trackVisitSearch(location_name, country) {
            pushPageVisitDimensions(location_name, 'search', null, country);
            return pushEvent(['visit search', location_name, undefined, undefined, true]);
        }

        trackSearchStart(searchParams, data, api, event) {
            pushEvent(['search', 'start', searchParams, undefined, true]);
            pushVirtualPage('search/start', 'Started Search');
            let search_data = getSearchData(data);

            /*
            searchData= {
                currency: "AED",
                driverAge:, 30,
                dropoff: {country: "US", location: undefined, id: "3716", iata: undefined, date: "05/24/2018"},
                duration: 0,
                leadDays: 0,
                pickup: {country: "US", location: undefined, id: "3716", iata: undefined, date: "05/12/2018"},
                residence:"AE"
            }
            */

            pushToFirebase('search', search_data);
        }

        trackSearchResult(total, data, api, event) {
            pushEvent(['search', 'result', `Cars: ${total}`, total, true]);
            pushVirtualPage('search/result', 'Search Result');

            let search_data = getSearchData(data);

            pushToFirebase('view_search_results', search_data);
        }

        trackEmptySearchResult(data, api, event) {
            pushEvent(['search', 'empty result', undefined, undefined, true]);
            pushVirtualPage('search/empty', 'Empty Search');

            let search_data = getSearchData(data);
            search_data['search_term'] = 'no results';
            pushToFirebase('view_search_results', search_data);
        }

        trackCarDetails(rank, price, data, api, event) {
            pushEvent(['booking', 'car details', rank]);
            pushVirtualPage('car/details', 'View Car');

            let search_data = getSearchData(data);

            let ct5_search = data.searchData;
            let ct5_vehicle = data.vehicleData;

            let car_data = $.extend(search_data, {
                // flight_number: '',
                travel_class: ct5_vehicle.code,
                content_type: ct5_vehicle.insurance.selected ? 'insured': 'not-insured',
                item_id: ct5_vehicle.referenceID,
                item_name: ct5_vehicle.name,
                item_category: ct5_vehicle.group,
                currency: ct5_search.currency,
                value: ct5_vehicle.amount.totalPrice,
                number_of_nights: data.searchData.duration,
                // number_of_rooms: '',
                // number_of_passengers: ''
            });

            pushToFirebase('view_item', car_data);
        }

        trackCarPrice(rank, price) {
            pushEvent(['booking', 'car price', rank, Math.round(price)]);
        }

        trackBestPrice() {
            pushEvent(['booking', 'car details/best price', 'best price']);
        }

        trackCheckoutError(error) {
            pushEvent(['checkout', 'checkout error', error]);
        }

        trackPaymentStart() {
            pushEvent(['checkout', 'payment started', 'start']);
            pushVirtualPage('payment', 'Payment Page');
        }

        trackPurchaseComplete(currency, price) {
            pushEvent(['checkout', 'complete', currency, Math.round(price)]);
        }

        trackPaymentComplete(charge) {
            pushEvent(['checkout', 'payment', 'complete', Math.round(charge)]);
        }

        trackPaymentError(charge) {
            pushEvent(['checkout', 'payment', 'error', Math.round(charge)]);
        }

        trackCarClick(locationName) {
            pushEvent(['visitor', 'clicked on car', locationName]);
            trackGoal('_carclick',
                {locationName});
        }

        trackPageWithCars(locationName) {
            pushEvent(['visitor', 'on page with cars', locationName, undefined, true]);
        }

        trackShowAds(locationName) {
            pushEvent(['ads', 'saw ads', locationName, undefined, true]);
        }

        trackUniqueContent(info) {
            pushEvent(['visitor', 'saw unique content', info || '', undefined, true]);
        }

        trackVisitArticle(info) {
            pushEvent(['visitor', 'on article', info || '', undefined, true]);
        }

        trackMatchingCarsFound(tailDetails) {
            pushEvent(['visitor', 'saw matching cars', tailDetails, undefined, true]);
        }

        trackMatchingCarsNotFound(info) {
            pushEvent(['visitor', 'no matching cars', info, undefined, true]);
        }

        trackValidationError(error) {
            pushEvent(['checkout', 'validation error', error.name + ': ' + error.value]);
        }

        trackCustomer() {
            pushEvent(['booking', 'customer']);
            pushVirtualPage('customer', 'Customer Form');
            pushToFirebase('begin_checkout', {});
        }

        trackCustomerEmail() {
            pushEvent(['booking', 'entered_email']);
            pushVirtualPage('customer-email', 'Customer Email');
        }

        trackPaymentInfo() {
            pushEvent(['booking', 'payment_info']);
            pushToFirebase('add_payment_info', {});
        }

        trackRental(_total, _now, _insurance, _car, ecommerce) {
            this.trackPaymentComplete(_total);

            pushEvent(['order', 'rental', 'total', Math.round(_total)]);
            pushEvent(['order', 'rental', 'now', Math.round(_now)]);
            pushEvent(['order', 'rental', 'insurance', Math.round(_insurance)]);
            pushEvent(['order', 'rental', 'car', Math.round(_car)]);

            if (ecommerce) {
                pushEcommerce(ecommerce);
            }

            pushVirtualPage('order', 'Ordered Rental');

            trackGoal('_purchase', {
                    total: _total,
                    now: _now,
                    insurance: _insurance,
                    car: _car
                }
            );
        }

        trackWrongFormParameters(data, api, event) {
            pushEvent(['search', 'wrong parameters']);
        }

        trackLocationChanged(pickup_or_return, in_search) {
            if (pickup_or_return == null) {
                pickup_or_return = undefined;
            }
            if (in_search == null) {
                in_search = false;
            }
            let event = 'change location';

            let v_url = 'select-location';
            let v_title = 'Change Location';

            if (pickup_or_return) {
                v_url += `/${pickup_or_return}`;
                v_title += ` (${pickup_or_return})`;
            }


            if (in_search) {
                event += ' in search';
                v_url += '/search';
                v_title += ' In Search';
            }

            pushEvent(['user', event, pickup_or_return]);
            pushVirtualPage(v_url, v_title);
        }

        trackDateChanged(from_search) {
            if (from_search == null) {
                from_search = false;
            }
            let event = 'date changed';
            let v_url = 'select-date';
            let v_title = 'Select Date';

            if (from_search) {
                event += ' in search';
                v_url += '/search';
                v_title += ' In Search';
            }

            pushEvent(['user', event]);
            pushVirtualPage(v_url, v_title);
        }

        trackTimeChanged(from_search) {
            if (from_search == null) {
                from_search = false;
            }
            let event = 'time changed';
            let v_url = 'select-time';
            let v_title = 'Select Time';

            if (from_search) {
                event += ' in search';
                v_url += '/search';
                v_title += ' In Search';
            }

            pushEvent(['user', event]);
            pushVirtualPage(v_url, v_title);
        }

        trackCurrencyChanged(from_search, _old, _new) {
            if (from_search == null) {
                from_search = false;
            }
            let event = 'currency changed';
            if (from_search) {
                event += ' in search';
            }
            pushEvent(['user', event, _old + ' to ' + _new]);
        }

        trackResidencyChanged(from_search, _old, _new) {
            if (from_search == null) {
                from_search = false;
            }
            let event = 'residency changed';
            if (from_search) {
                event += ' in search';
            }
            pushEvent(['user', event, _old + ' to ' + _new]);
        }

        trackRateDetails(param) {
            let v_url = 'rental-conditions';
            let v_title = 'View Rental Conditions';

            pushEvent(['booking', 'rental conditions', param]);

            if (param != null) {
                v_url += '/payment';
                v_title += ' On Payment';
            }

            pushVirtualPage(v_url, v_title);
        }

        trackEmailQuoteOpen() {
            pushEvent(['booking', 'email quote open']);
        }

        trackEmailQuoteSent() {
            pushEvent(['booking', 'email quote sent']);
        }

        trackStartApp(app) {
            pushEvent(['application', 'start', app, undefined, true]);
        }

        trackLanguageChange(old_lang, new_lang) {
            pushEvent(['application', 'change_language', "from: " + old_lang, "to: " + new_lang])
        }

        enableMobileTracking() {
            this.beMobile = true;
        }
    };

    return new Analytics();
});